import { lazy } from "react";
import { GrIntegration } from "react-icons/gr";
import {
  IoPerson,
  IoSettingsOutline,
  IoSpeedometerOutline,
} from "react-icons/io5";
import { LuBot, LuFileText, LuHelpCircle, LuUsers } from "react-icons/lu";
import {
  MdOutlineMessage,
  MdOutlinePeopleAlt,
  MdOutlineShoppingCart,
  MdOutlineSubscriptions,
} from "react-icons/md";
import {
  TbCategoryPlus,
  TbReportSearch,
  TbUserCog,
  TbUserShield,
} from "react-icons/tb";

const ViewChat = lazy(() => import("../pages/ViewChat"));
const SystemSettings = lazy(() => import("../pages/SystemSettings"));
const IntegrationManagement = lazy(() =>
  import("../pages/IntegrationManagement")
);
const Login = lazy(() => import("../pages/Login"));
const Roles = lazy(() => import("../pages/Roles"));
const AddRole = lazy(() => import("../pages/AddRole"));
const EditRole = lazy(() => import("../pages/EditRole"));
const AddSubscription = lazy(() => import("../pages/AddSubscription"));
const EditSubscription = lazy(() => import("../pages/EditSubscription"));
const SubscriptionManagement = lazy(() =>
  import("../pages/SubscriptionManagement")
);
const ViewSubscription = lazy(() => import("../pages/ViewSubscription"));
const PurchaseCommission = lazy(() => import("../pages/PurchaseCommission"));
const OrderDetails = lazy(() => import("../pages/OrderDetails"));
const Dashboard = lazy(() => import("../pages/Dashboard"));

const UserManagement = lazy(() => import("../pages/UserManagement"));
const AccountSettings = lazy(() => import("../pages/AccountSettings"));
const ReportingAnalytics = lazy(() => import("../pages/ReportingAnalytics"));
const StaffManagement = lazy(() => import("../pages/StaffManagement"));
const AddEditStaff = lazy(() => import("../pages/AddEditStaff"));
const StaffDetails = lazy(() =>
  import("../pages/StaffManagement/StaffDetails")
);
const BotManagement = lazy(() => import("../pages/BotManagement"));
const Notifications = lazy(() => import("../pages/Notifications"));
const UserDetails = lazy(() => import("../pages/UserManagement/UserDetails"));
const ProductDetails = lazy(() => import("../pages/ProductDetails"));
const Cms = lazy(() => import("../pages/Cms"));
const Faqs = lazy(() => import("../pages/Faqs"));
const Blogs = lazy(() => import("../pages/Blogs"));
const AddEditBlogs = lazy(() => import("../pages/AddEditBlogs"));
const ContactUs = lazy(() => import("../pages/ContactUs"));
export const routes = [
  {
    path: "/",
    exact: true,
    protected: true,
    showInSidebar: true,
    title: "Dashboard",
    icon: <IoSpeedometerOutline />,
    element: <Dashboard />,
  },
  {
    path: "/login",
    exact: true,
    protected: false,
    element: <Login />,
  },
  {
    path: "/user-management",
    exact: true,
    protected: true,
    showInSidebar: true,
    title: "User Management",
    icon: <LuUsers />,
    element: <UserManagement />,
  },
  {
    path: "/integration-management",
    exact: true,
    protected: true,
    showInSidebar: true,
    title: "Integration Management",
    icon: <GrIntegration />,
    element: <IntegrationManagement />,
  },
  {
    path: "/user-management/view/:slug",
    exact: true,
    protected: true,
    element: <UserDetails />,
  },
  {
    path: "/product-details/view/:id",
    exact: true,
    protected: true,
    showInSidebar: false,
    icon: <MdOutlinePeopleAlt />,
    element: <ProductDetails />,
  },

  {
    path: "/reporting-analytics",
    exact: true,
    protected: true,
    showInSidebar: true,
    title: "Reporting & Analytics",
    icon: <TbReportSearch />,
    element: <ReportingAnalytics />,
  },
  {
    path: "/purchase-commission",
    exact: true,
    protected: true,
    showInSidebar: true,
    title: "Purchase & Commission",
    icon: <MdOutlineShoppingCart />,
    element: <PurchaseCommission />,
  },
  {
    path: "/orders/:orderid",
    exact: true,
    protected: true,
    showInSidebar: false,
    title: "Purchase & Commission",
    icon: <MdOutlineShoppingCart />,
    element: <OrderDetails />,
  },
  {
    path: "/subscription-management",
    exact: true,
    protected: true,
    showInSidebar: true,
    title: "Subscription Management",
    icon: <MdOutlineSubscriptions />,
    element: <SubscriptionManagement />,
  },
  {
    path: "/system-settings",
    exact: true,
    protected: true,
    showInSidebar: true,
    title: "System Settings",
    icon: <IoSettingsOutline />,
    element: <SystemSettings />,
  },
  {
    path: "/subscription-management/view/:id",
    exact: true,
    protected: true,
    showInSidebar: false,
    element: <ViewSubscription />,
  },
  {
    path: "/subscription-management/edit/:id",
    exact: true,
    protected: true,
    showInSidebar: false,
    element: <EditSubscription />,
  },
  {
    path: "/subscription-management/add",
    exact: true,
    protected: true,
    showInSidebar: false,
    element: <AddSubscription />,
  },
  {
    path: "/roles",
    exact: true,
    protected: true,
    showInSidebar: true,
    title: "Roles",
    icon: <TbUserCog />,
    element: <Roles />,
  },
  {
    path: "/roles/add",
    exact: true,
    protected: true,
    element: <AddRole />,
  },
  {
    path: "/roles/edit/:id",
    exact: true,
    protected: true,
    element: <EditRole />,
  },
  {
    path: "/staff",
    exact: true,
    protected: true,
    showInSidebar: true,
    title: "Staff",
    icon: <TbUserShield />,
    element: <StaffManagement />,
  },
  {
    path: "/staff/view/:slug",
    exact: true,
    protected: true,
    showInSidebar: false,
    element: <StaffDetails />,
  },
  {
    path: "/staff/add",
    exact: true,
    protected: true,
    showInSidebar: false,
    element: <AddEditStaff />,
  },

  {
    path: "/bot",
    exact: true,
    protected: true,
    showInSidebar: true,
    title: "BOT",
    icon: <LuBot />,
    element: <BotManagement />,
  },
  {
    path: "/blogs",
    exact: true,
    protected: true,
    showInSidebar: true,
    title: "Blogs",
    icon: <LuFileText />,
    element: <Blogs />,
  },
  {
    path: "/blogs/add",
    exact: true,
    protected: true,
    element: <AddEditBlogs />,
  },
  {
    path: "/blogs/edit/:id",
    exact: true,
    protected: true,
    element: <AddEditBlogs />,
  },
  {
    path: "/contact-us",
    exact: true,
    protected: true,
    showInSidebar: true,
    title: "Contact Us",
    icon: <MdOutlineMessage />,
    element: <ContactUs />,
  },
  {
    path: "/faqs",
    exact: true,
    protected: true,
    showInSidebar: true,
    title: "FAQs",
    icon: <LuHelpCircle />,
    element: <Faqs />,
  },
  {
    path: "/cms",
    exact: true,
    protected: true,
    showInSidebar: true,
    title: "CMS",
    icon: <TbCategoryPlus />,
    element: <Cms />,
  },
  {
    path: "/view-chat/:id",
    exact: true,
    protected: true,
    element: <ViewChat />,
  },
  {
    path: "/account-settings",
    exact: true,
    protected: true,
    showInSidebar: false,
    title: "Account Settings",
    icon: <IoPerson />,
    element: <AccountSettings />,
  },
  {
    path: "/notifications",
    exact: true,
    protected: true,
    showInSidebar: false,
    element: <Notifications />,
  },
];
